export default "__VITE_ASSET__73798a40__"